import React from 'react';
import SegmentPageTemplate from '../components/SegmentPageTemplate';
import segmentConfigs from '../config/segmentConfigs';

const LocacaoIndustria = () => {
  return <SegmentPageTemplate {...segmentConfigs.industria} />;
};

export default LocacaoIndustria;